import { call, put, select, takeEvery } from "redux-saga/effects";
import { steps } from "../../util/constants";
import { setBackButtonDestination } from "../backButtonDestination/backButtonDestination";
import {
  clearCheckpoint,
  createHotspot,
  locationChangeIntent,
  setCurrentHotspot,
  setCurrentStep,
} from "../hotspotEditor/hotspotEditorReducers";
import { getHotspotCount } from "../selectors";
import { addHotspotFromUI } from "./sagasActions";
import { locationSetIntentWorker } from "./locationSetIntentSaga";

function* addHotspotFromUIWorker(action) {
  const hotspotIndex = yield select(getHotspotCount);
  yield put(createHotspot());
  yield put(setCurrentHotspot(hotspotIndex));
  yield put(setBackButtonDestination("preview"));
  yield put(setCurrentStep(steps.configureLocations));
  if (action.payload) {
    yield put(locationChangeIntent({ hotspotIndex, ...action.payload }));
    yield call(locationSetIntentWorker);
  }
  yield put(clearCheckpoint());
}

export function* addHotspotFromUIWatcher() {
  yield takeEvery(addHotspotFromUI().type, addHotspotFromUIWorker);
}
